var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-left"},[_c('p',[_vm._v(_vm._s(this.parse()))])])
}
var staticRenderFns = []

export { render, staticRenderFns }